import { useQuery } from '@fv/client-core'
import type { SystemNotification } from '@fv/models'
import type { DTO } from '@fv/models/core'

import { carrierFetch } from '@/utils/carrierFetch'

export const systemNotificationQueryKeys = {
  all: ['system-notifications'],
}

export const useSystemNotifications = () => {
  return useQuery(systemNotificationQueryKeys.all, () =>
    carrierFetch<Array<DTO<SystemNotification>>>('/notifications/system'),
  )
}
